<template>
<div id="kongzhi">
     
</div>
</template>

<script>
   
export default {
    name: 'kongzhi',
    data() {
      return {

      }
    },
    methods: {

    },
    created(){

       
    }
  }
</script>


<style scoped>
.option{
    display: inline-block;
    border: 1px solid #ebeef5;
    width: 100%;
    margin-top: 1rem;
    line-height: 4rem;
    text-align: center;
}
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kongzhi.vue